// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"ca3c9779","161":"09cbe845","280":"59685a66","326":"d108e984","340":"e75e71ca","366":"c4539cab","393":"7de416e6","397":"500e5c31","510":"afc42c19","511":"d0939c73","672":"244c1d04","802":"d16104a6","841":"40b80987","971":"808c281a","981":"8b9e5075"}[chunkId] + ".chunk.js";
};